// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3GcTM","signatureButtonsRight":"ModalSign_signatureButtonsRight__5j40M"};